
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[product_query]",
      function () {
        return require("private-next-pages/product/[product_query]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[product_query]"])
      });
    }
  